import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, effect, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, viewChild } from '@angular/core';
import { BehaviorSubject, take } from 'rxjs';
import { PdfRetrievalService } from '../../shared/services/pdf-retrieval.service';
import { DacklEmptyStateComponent } from '@datev/ngx-dackl';
import { PushPipe } from '@ngrx/component';

import '@datev/doc-viewer';

@Component({
  selector: 'dp-product-doc-view',
  templateUrl: './product-doc-view.component.html',
  styleUrls: ['./product-doc-view.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    DacklEmptyStateComponent,
    PushPipe,
  ],
})
export class ProductDocViewComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input()
  public source = '';

  viewerRef = viewChild<ElementRef>('viewer');
  private mediaQueryList: MediaQueryList | undefined;
  private resizeListener: () => void = () => this.applyShadowDomFix();

  private pdfDataState = new BehaviorSubject<{ buffer: ArrayBuffer; fileName: string } | null>(null);

  public pdfData$ = this.pdfDataState.asObservable();

  constructor(private readonly pdfRetrievalService: PdfRetrievalService) { 
    effect(() => {
      const viewerRef = this.viewerRef();
      if (viewerRef) {
        setTimeout(() => this.applyShadowDomFix(), 50);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.source && changes.source.currentValue !== '') {
      this.pdfRetrievalService
        .getPdfData(changes.source.currentValue)
        .pipe(take(1))
        .subscribe({
          next: data => {
            this.pdfDataState.next({ buffer: data, fileName: `${crypto.randomUUID()}.pdf` });
          },
        });
    }
  }

  ngAfterViewInit(): void {
    this.mediaQueryList = window.matchMedia('(max-width: 639px)');
    this.mediaQueryList.addEventListener('change', this.resizeListener);
  }

  ngOnDestroy(): void {
    if (this.mediaQueryList) {
      this.mediaQueryList.removeEventListener('change', this.resizeListener);
    }
  }

  private applyShadowDomFix(): void {
    const hostEl = this.viewerRef()?.nativeElement as HTMLElement;

    if (!hostEl?.shadowRoot)
      return;

    const innerDiv = hostEl.shadowRoot.querySelector('.doc-viewer') as HTMLElement;
    if (!innerDiv)
      return;

    if (this.mediaQueryList?.matches) {
      innerDiv.style.setProperty('position', 'static', 'important');
    } else {
      innerDiv.style.removeProperty('position');
    }
  }
}
